<template>
    <div class="content-scroll">
        <div class="content-box page">
            <el-form ref="form" :inline="true" :model="filters" style="top: 5px">
                <el-form-item label="搜索日期">
                    <el-select v-model="filters.year" clearable  placeholder="请选择年份">
                        <el-option
                                v-for="item in years"
                                :key="item"
                                :label="item"
                                :value="item">
                        </el-option>
                    </el-select>
                    <el-select v-model="filters.month" clearable  placeholder="请选择月份">
                        <el-option
                                v-for="item in months"
                                :key="item"
                                :label="item"
                                :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="info" icon="el-icon-search" @click="searchHomePage()">搜索</el-button>
                </el-form-item>
            </el-form>

            <el-tabs active-name="first" class="pageTitle">
                <el-tab-pane label="客户跟进情况" name="first"></el-tab-pane>
            </el-tabs>
            <el-row :gutter="20">
                <el-col :span="4">
                    <div>
                        <el-statistic :value="customerTrackStateResp.sameDayNew" title="今日新增客户"></el-statistic>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div>
                        <el-statistic :value="customerTrackStateResp.sameDayTrack" title="今日跟进客户">
                        </el-statistic>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div>
                        <el-statistic :value="customerTrackStateResp.l7DayTrack" title="7天跟进客户">
                        </el-statistic>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div>
                        <el-statistic :value="customerTrackStateResp.l30DayTrack" title="30天跟进客户">
                        </el-statistic>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div>
                        <el-statistic :value="customerTrackStateResp.totalTrack" title="总跟进客户">
                        </el-statistic>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div>
                        <el-statistic :value="customerTrackStateResp.totalCustomer" title="总客户">
                        </el-statistic>
                    </div>
                </el-col>
            </el-row>
            <el-tabs active-name="first" class="pageTitle">
                <el-tab-pane label="销售额TOP5" name="first"></el-tab-pane>
            </el-tabs>
            <el-row :gutter="20">
                <el-col :span="7">
                    <div class="grid-content bg-purple">
                        <template>
                            <el-table
                                    :data="countryRankingList" border v-loading="tLoading">
                                <el-table-column
                                        prop="name"
                                        label="国家"
                                        align="center">
                                </el-table-column>
                                <el-table-column
                                        prop="value"
                                        label="销售额"
                                        align="center">
                                </el-table-column>
                            </el-table>
                        </template>
                    </div>
                </el-col>
                <el-col :span="10">
                    <div class="grid-content bg-purple">
                        <el-table
                                :data="customerRankingList" border v-loading="tLoading"
                                style="width: 100%">
                            <el-table-column
                                    prop="name"
                                    label="客户类型"
                                    align="center">
                            </el-table-column>
                            <el-table-column
                                    prop="value"
                                    label="销售额"
                                    align="center">
                            </el-table-column>
                        </el-table>
                    </div>
                </el-col>
                <el-col :span="7">
                    <div class="grid-content bg-purple">
                        <el-table
                                :data="productRankingList" border v-loading="tLoading"
                                style="width: 100%">
                            <el-table-column
                                    prop="name"
                                    label="产品类型"
                                    align="center">
                            </el-table-column>
                            <el-table-column
                                    prop="value"
                                    label="销售额"
                                    align="center">
                            </el-table-column>
                        </el-table>
                    </div>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="7">
                    <div class="grid-content bg-purple">
                        <template>
                            <el-table
                                    :data="customerSourceRankingList" border v-loading="tLoading">
                                <el-table-column
                                        prop="name"
                                        label="客户来源"
                                        align="center">
                                </el-table-column>
                                <el-table-column
                                        prop="value"
                                        label="销售额"
                                        align="center">
                                </el-table-column>
                            </el-table>
                        </template>
                    </div>
                </el-col>
                <el-col :span="10">
                    <div class="grid-content bg-purple">
                        <el-table
                                :data="customerLevelRankingList" border v-loading="tLoading"
                                style="width: 100%">
                            <el-table-column
                                    prop="name"
                                    label="客户等级"
                                    align="center">
                            </el-table-column>
                            <el-table-column
                                    prop="value"
                                    label="销售额"
                                    align="center">
                            </el-table-column>
                        </el-table>
                    </div>
                </el-col>
            </el-row>
            <el-tabs active-name="first" class="pageTitle">
                <el-tab-pane label="销售额排序" name="first"></el-tab-pane>
            </el-tabs>
            <el-row>
                <el-col>
                    <el-statistic group-separator="," :precision="2" :value="this.totalAmount"
                                  title="总销售额"></el-statistic>
                </el-col>
            </el-row>
            <el-row>
                <el-col>
                    <div class="bg-purple">
                        <chart class="mychart page" style="height: 300px" :option="charOptions"></chart>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
    import Chart from "vue-echarts-v3";

    export default {
        components: {
            Chart
        },
        name: 'count',
        data() {
            return {
                filters: {
                    year: null,
                    month: null,
                },
                years: [],
                months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
                countryRankingListUrl: '/home/page/countryRankingList',
                customerRankingListUrl: '/home/page/customerRankingList',
                productRankingListUrl: '/home/page/productRankingList',
                customerSourceRankingListUrl: '/home/page/customerSourceRankingList',
                customerLevelRankingListUrl: '/home/page/customerLevelRankingList',
                customerTrackStateUrl: '/home/page/customerTrackState',
                amountsRankingUrl: '/home/page/amountsRanking',
                countryRankingList: [],
                customerRankingList: [],
                productRankingList: [],
                customerSourceRankingList: [],
                customerLevelRankingList: [],
                amountsRankingList: [],
                customerTrackStateResp: {
                    sameDayNew: 0,
                    sameDayTrack: 0,
                    l7DayTrack: 0,
                    l30DayTrack: 0,
                    totalTrack: 0,
                    totalCustomer: 0,
                },
                totalAmount: 0,
                charOptions: {
                    xAxis: {
                        type: 'category',
                        data: [],
                        axisPointer: {
                            type: 'shadow'
                        }
                    },
                    yAxis: {
                        type: 'value',
                    },
                    series: [
                        {
                            data: [],
                            type: 'line',
                            itemStyle: {
                                emphasis: {
                                    label: {
                                        show: true,

                                        // //label展示的时候再把数值转换回来，不然会展示百分比♥♥♥
                                        formatter: function (params) {
                                            return params.data.toLocaleString();
                                        },

                                    }
                                }
                            }
                        }
                    ]
                }
            }
        },
        methods: {
            getAmountsRankingList() {
                this.tLoading = true;
                this.request(this.amountsRankingUrl, this.filters, (res) => {
                    if (res.length != 0) {
                        this.charOptions.xAxis.data = res.map(item => item.yearMonth)
                        this.charOptions.series[0].data = res.map(item => item.amount / 100)
                        this.totalAmount = this.sum(this.charOptions.series[0].data)
                    } else {
                        this.charOptions.xAxis.data = []
                        this.charOptions.series[0].data = []
                        this.totalAmount = 0
                    }
                }, 'postJson', true)
            },
            getCustomerTrackState() {
                this.tLoading = true;
                this.request(this.customerTrackStateUrl, this.filters, (res) => {
                    this.customerTrackStateResp = res;
                }, 'postJson', true)
            },
            getCountryRankingList() {
                this.tLoading = true;
                this.request(this.countryRankingListUrl, this.filters, (res) => {
                    this.countryRankingList = res;
                }, 'postJson', true)
            },
            getCustomerRankingList() {
                this.tLoading = true;
                this.request(this.customerRankingListUrl, this.filters, (res) => {
                    this.customerRankingList = res;
                }, 'postJson', true)
            },
            getProductRankingList() {
                this.tLoading = true;
                this.request(this.productRankingListUrl, this.filters, (res) => {
                    this.productRankingList = res;
                }, 'postJson', true)
            },

            getCustomerSourceRankingList() {
                this.tLoading = true;
                this.request(this.customerSourceRankingListUrl, this.filters, (res) => {
                    this.customerSourceRankingList = res;
                }, 'postJson', true)
            },

            getCustomerLevelRankingList() {
                this.tLoading = true;
                this.request(this.customerLevelRankingListUrl, this.filters, (res) => {
                    this.customerLevelRankingList = res;
                }, 'postJson', true)
            },
            sum(arr) { // 数组求和
                return eval(arr.join('+'));
            },
            searchHomePage() {
                this.getCustomerTrackState();
                this.getCountryRankingList()
                this.getCustomerRankingList()
                this.getProductRankingList()
                this.getAmountsRankingList()
                this.getCustomerSourceRankingList()
                this.getCustomerLevelRankingList()
            },
            setYears() {
                let now = new Date()
                let nowYear = now.getFullYear();
                for (let i = 2019; i <= nowYear; i++) {
                    this.years.push(i)
                }
            }

        },
        mounted() {
            this.setYears()
            this.getCustomerTrackState();
            this.getCountryRankingList();
            this.getCustomerRankingList();
            this.getProductRankingList();
            this.getAmountsRankingList()
            this.getCustomerSourceRankingList()
            this.getCustomerLevelRankingList()
        },
    }
</script>
<style lang="less">
    .myMian {
        position: absolute;
        top: 10px;
        left: 10px;
        right: 10px;
    }

    .el-row {
        margin-bottom: 20px;

        &:last-child {
            margin-bottom: 0;
        }
    }

    .el-col {
        border-radius: 4px;
    }

    .bg-purple-dark {
        background: #99a9bf;
    }

    .bg-purple {
        background: #d3dce6;
    }

    .bg-purple-light {
        background: #e5e9f2;
    }

    .grid-content {
        border-radius: 4px;
        min-height: 36px;
    }

    .grid-content-1 {
        border-radius: 4px;
        min-height: 60px;
    }

    .row-bg {
        padding: 10px 0;
        background-color: #f9fafc;
    }
</style>